import store from '@/store/index.js'

export default {
    uploadFile: (file, key, uploadProgress) => {
        return new Promise((resolve, reject) => {
            //创建form对象
            let param = new FormData(); //创建form对象
            let fileKey = key
            if (!fileKey) {
                //'gx-material-'
                let userInfo = JSON.parse(store.state.userInfo)  || {}
                fileKey = userInfo.username + '-' + new Date().getTime() + file.name.substring(file.name.lastIndexOf('.'))
            }

            const uploadToOSS = (uploadUrl, getHost) => {
                let defaultUploadProgress = progressEvent => {
                    let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
                }

                let onUploadProgress = uploadProgress || defaultUploadProgress

                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Access-Control-Allow-Origin': '*'
                    },
                    onUploadProgress: progressEvent => {
                        onUploadProgress(progressEvent)
                    }
                };

                axios.post(getHost, param, config)
                    .then(response => {
                        const newFileUrl = getHost + '/' + fileKey
                        resolve(newFileUrl, fileKey)
                    }, (err) => {
                        reject(err)
                    })
            }

            axios.get(Urls.URL.upload_url).then(response => {
                if (response.data) {
                    let data = response.data
                    param.append('OSSAccessKeyId', data.data.accessKeyId)
                    param.append('policy', data.data.policy)
                    param.append('Signature', data.data.signature)
                    param.append('success_action_status', '200')
                    param.append('name', file.name)
                    // 设置文件key
                    param.append('key', fileKey)
                    param.append('file', file)
                    uploadToOSS(data.data.endpoint, data.data.host)
                } else {
                    reject(null)
                }
            }).catch(err => {
                reject(err)
            })


            // reject(err)
            // resolve(devWebpackConfig)
        })
    }
}
